import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  Flex,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  useDisclosure,
  Text,
  Editable,
  EditablePreview,
  EditableInput,
  Input,
} from "@chakra-ui/react";
import ReactSelect from "react-select";
import axios from "axios";
import apiUrl from "variables/api";
import { toast } from "react-toastify";
import darkStyles from "variables/darkStyles";
import { set } from "react-hook-form";
import { FaBackward, FaEraser, FaTrash } from "react-icons/fa";
import { FaBackwardStep } from "react-icons/fa6";

export default function UsersModal({
  isOpen,
  onClose,
  onOpen,
  usersData,
  fetchUsersData,
  actualCompany,
  peoples,
}) {
  const [selectedUsersPlatoon1, setSelectedUsersPlatoon1] = useState([]);
  const [selectedUsersPlatoon2, setSelectedUsersPlatoon2] = useState([]);
  const [selectedUsersPlatoon3, setSelectedUsersPlatoon3] = useState([]);
  const [logins, setLogins] = useState({});
  const {
    isOpen: isAddUserOpen,
    onOpen: onAddUserOpen,
    onClose: onAddUserClose,
  } = useDisclosure();
  const {
    isOpen: isLoginsModalOpen,
    onOpen: onLoginsModalOpen,
    onClose: onLoginsModalClose,
  } = useDisclosure();

  const clearSelected = () => {
    setSelectedUsersPlatoon1([]);
    setSelectedUsersPlatoon2([]);
    setSelectedUsersPlatoon3([]);
    setLogins({});
  };

  const [isNumberModalOpen, setIsNumberModalOpen] = useState(false);
  const [editedNumbers, setEditedNumbers] = useState({});

  const handleAddUsers = () => {
    const newUsers = {
      platoon1: selectedUsersPlatoon1?.map((user) => user.value),
      platoon2: selectedUsersPlatoon2?.map((user) => user.value),
      platoon3: selectedUsersPlatoon3?.map((user) => user.value),
      actualCompany: actualCompany.id,
      logins: logins,
    };

    axios
      .post(apiUrl + "/data/school/company/users/add", newUsers, {
        headers: { "x-access-token": localStorage.getItem("token") },
      })
      .then((response) => {
        toast.success("Pomyślnie dodano użytkowników");
        onAddUserClose();
        onLoginsModalClose();
        clearSelected();
        fetchUsersData();
        onClose();
        setTimeout(() => onOpen(), 500);
      })
      .catch((error) => {
        console.error(error);
        toast.error("Napotkano błąd podczas dodawania użytkowników");
      });
  };

  const handleLoginsChange = (userId, login) => {
    setLogins((prevLogins) => ({
      ...prevLogins,
      [userId]: login,
    }));
  };

  const archiveUser = (userId) => {
    axios
      .post(
        apiUrl + "/data/school/company/users/archive",
        { userId },
        {
          headers: { "x-access-token": localStorage.getItem("token") },
        }
      )
      .then((response) => {
        toast.success("Pomyślnie wykreślono użytkownika");
        fetchUsersData();
        onClose();
        setTimeout(() => onOpen(), 500);
      })
      .catch((error) => {
        console.error(error);
        toast.error("Napotkano błąd podczas wykreślania użytkownika");
      });
  };

  const unArchiveUser = (userId) => {
    axios
      .post(
        apiUrl + "/data/school/company/users/unarchive",
        { userId },
        {
          headers: { "x-access-token": localStorage.getItem("token") },
        }
      )
      .then((response) => {
        toast.success("Pomyślnie przywrócono użytkownika");
        fetchUsersData();
        onClose();
        setTimeout(() => onOpen(), 500);
      })
      .catch((error) => {
        console.error(error);
        toast.error("Napotkano błąd podczas przywracania użytkownika");
      });
  };


  const deleteUser = (userId) => {
    axios
      .post(
        apiUrl + "/data/school/company/users/remove",
        { id: userId },
        {
          headers: { "x-access-token": localStorage.getItem("token") },
        }
      )
      .then((response) => {
        toast.success("Pomyślnie usunięto użytkownika");
        fetchUsersData();
        onClose();
        setTimeout(() => onOpen(), 500);
      })
      .catch((error) => {
        console.error(error);
        toast.error("Napotkano błąd podczas usuwania użytkownika");
      });
  }

  const handleNumberChange = (userId, newNumber) => {
    setEditedNumbers((prev) => ({
      ...prev,
      [userId]: newNumber,
    }));
    console.log(editedNumbers);
  };

  const handleSaveNumbers = async () => {
    try {
      for (const userId in editedNumbers) {
        const newNumber = editedNumbers[userId];
        await axios.post(
          apiUrl + "/data/school/company/users/update",
          { userId, newNumber },
          {
            headers: { "x-access-token": localStorage.getItem("token") },
          }
        );
      }
      toast.success("Pomyślnie zmieniono numery w plutonie");
      fetchUsersData();
      setEditedNumbers({});
      onClose();
      setTimeout(() => onOpen(), 500);

      // setIsNumberModalOpen(false);
    } catch (error) {
      console.error(error);
      toast.error("Napotkano błąd podczas zmiany numerów w plutonie");
    }
  };
  

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose} size="3xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Zarządzanie użytkownikami</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Flex direction="column" gap="4">
              <Table variant="simple">
                <Thead>
                  <Tr>
                    <Th>Pluton</Th>
                    <Th>Nr. w plutonie</Th>
                    <Th>Użytkownicy</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {usersData
                    .sort((a, b) => {
                      const platoonComparison = a.platoon
                        .toString()
                        .localeCompare(b.platoon.toString());
                      if (platoonComparison !== 0) {
                        return platoonComparison;
                      }
                      return a.number - b.number;
                    })
                    .map((user, index) => {
                      return (
                        <Tr key={index}>
                          <Td>{user.platoon}</Td>
                          <Td>
                            <Editable
                              defaultValue={user.number}
                              onSubmit={(value) =>
                                handleNumberChange(user.id, value, user.platoon)
                              }
                            >
                              <EditablePreview />
                              <EditableInput />
                            </Editable>
                          </Td>
                          <Td>
                            {peoples.find(
                              (person) => person.value === user.userID
                            )?.label || "Nieznany użytkownik"}
                          </Td>
                          <Td>
                            <Button
                              colorScheme={user.archived ? "green" : "red"}
                              onClick={() => {
                                if (user.archived) {
                                  unArchiveUser(user.id);
                                } else {
                                archiveUser(user.id);
                                }
                              }}
                            >
                              {user.archived ? <FaBackward /> : <FaEraser />}
                            </Button>
                          </Td>
                          {(localStorage
                            .getItem("roles")
                            .includes("973337145844584538") ||
                            localStorage
                              .getItem("roles")
                              .includes("1190995987154616381")) && (<Td>
                                <Button colorScheme="red" onClick={() => {
                                  deleteUser(user.id);
                                }} disabled={user.archived}>
                                  <FaTrash />
                                </Button>
                              </Td>)}
                        </Tr>
                      );
                    })}
                </Tbody>
              </Table>
              <Flex justify="space-between">
              <Button colorScheme="green" onClick={onAddUserOpen}>
                Dodaj użytkowników
              </Button>
              {Object.keys(editedNumbers).length > 0 && (
              <Button colorScheme="gray" onClick={handleSaveNumbers}>
                Zapisz zmiany numerów
              </Button>
                )}
              </Flex>
            </Flex>
          </ModalBody>
        </ModalContent>
      </Modal>

      <Modal isOpen={isAddUserOpen} onClose={onAddUserClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Dodaj użytkowników</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Flex direction="column" gap="4">
              <Text>Pluton 1</Text>
              <ReactSelect
                isMulti
                options={peoples.filter(
                  (user) =>
                    !selectedUsersPlatoon2.includes(user) &&
                    !selectedUsersPlatoon3.includes(user) &&
                    !usersData.some(
                      (userData) => userData.userID === user.value
                    )
                )}
                placeholder="Wybierz użytkowników..."
                styles={darkStyles()}
                onChange={setSelectedUsersPlatoon1}
              />
              <Text>Pluton 2</Text>
              <ReactSelect
                isMulti
                options={peoples.filter(
                  (user) =>
                    !selectedUsersPlatoon1.includes(user) &&
                    !selectedUsersPlatoon3.includes(user) &&
                    !usersData.some(
                      (userData) => userData.userID === user.value
                    )
                )}
                placeholder="Wybierz użytkowników..."
                styles={darkStyles()}
                onChange={setSelectedUsersPlatoon2}
              />
              <Text>Pluton 3</Text>
              <ReactSelect
                isMulti
                options={peoples.filter(
                  (user) =>
                    !selectedUsersPlatoon1.includes(user) &&
                    !selectedUsersPlatoon2.includes(user) &&
                    !usersData.some(
                      (userData) => userData.userID === user.value
                    )
                )}
                placeholder="Wybierz użytkowników..."
                styles={darkStyles()}
                onChange={setSelectedUsersPlatoon3}
              />
            </Flex>
          </ModalBody>
          <ModalFooter>
            <Button
              colorScheme="red"
              mr={3}
              onClick={() => {
                onAddUserClose();
                clearSelected();
              }}
            >
              Anuluj
            </Button>
            <Button colorScheme="green" onClick={onLoginsModalOpen}>
              Dalej
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Modal isOpen={isLoginsModalOpen} onClose={onLoginsModalClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Uzupełnij loginy użytkowników</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Flex direction="column" gap="4">
              <Table variant="simple">
                <Thead>
                  <Tr>
                    <Th>Nick</Th>
                    <Th>Login</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {[
                    ...selectedUsersPlatoon1,
                    ...selectedUsersPlatoon2,
                    ...selectedUsersPlatoon3,
                  ].map((user, index) => (
                    <Tr key={index}>
                      <Td>{user.label}</Td>
                      <Td>
                        <Input
                          placeholder="Wpisz login"
                          value={logins[user.value] || ""}
                          onChange={(e) =>
                            handleLoginsChange(user.value, e.target.value)
                          }
                        />
                      </Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            </Flex>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="red" mr={3} onClick={onLoginsModalClose}>
              Anuluj
            </Button>
            <Button colorScheme="green" onClick={handleAddUsers}>
              Dodaj
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
